"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDateTimeFormat = createDateTimeFormat;
exports.DateTimeFormat = void 0;

var _lodashEs = require("lodash-es");

var _dayjs = _interopRequireDefault(require("dayjs"));

var _relativeTime = _interopRequireDefault(require("dayjs/plugin/relativeTime"));

var _localizedFormat = _interopRequireDefault(require("dayjs/plugin/localizedFormat"));

var _advancedFormat = _interopRequireDefault(require("dayjs/plugin/advancedFormat"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

_dayjs["default"].extend(_relativeTime["default"]);

_dayjs["default"].extend(_localizedFormat["default"]);

_dayjs["default"].extend(_advancedFormat["default"]);
/**
 * @todo use `dateStyle` and `timeStyle` when have sufficient support
 * https://caniuse.com/mdn-javascript_builtins_intl_datetimeformat_datetimeformat_datestyle
 * https://caniuse.com/mdn-javascript_builtins_intl_datetimeformat_datetimeformat_timestyle
 */


var DateTimeFormat = {};
exports.DateTimeFormat = DateTimeFormat;
DateTimeFormat.DEFAULT = {};
DateTimeFormat.DATE_TIME = __assign(__assign({}, DateTimeFormat.DEFAULT), {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric'
});
DateTimeFormat.DATE_TIME_LONG = __assign(__assign({}, DateTimeFormat.DATE_TIME), {
  month: 'long'
});
DateTimeFormat.DATE = __assign(__assign({}, DateTimeFormat.DEFAULT), {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric'
});
DateTimeFormat.DATE_LONG = __assign(__assign({}, DateTimeFormat.DATE), {
  month: 'long'
});
DateTimeFormat.DATE_SHORT = __assign(__assign({}, DateTimeFormat.DATE), {
  month: 'short'
});
DateTimeFormat.TIME = __assign(__assign({}, DateTimeFormat.DEFAULT), {
  hour: 'numeric',
  minute: 'numeric'
});

function createDateTimeFormat(locale) {
  var getFormatter = (0, _lodashEs.memoize)(function (options) {
    return new Intl.DateTimeFormat(locale, options);
  }, function (options) {
    return JSON.stringify(options, Object.keys(options).sort());
  });

  function formatDateTime(date, options) {
    if (options === void 0) {
      options = DateTimeFormat.DEFAULT;
    }

    return getFormatter(options).format(new Date(date));
  }

  function formatDateTimeRange(value1, value2, options) {
    if (options === void 0) {
      options = DateTimeFormat.DEFAULT;
    }

    return [value1, value2].filter(Boolean).map(function (value) {
      return formatDateTime(value, options);
    }).join(' - ');
  }
  /**
   * @todo reimplement in RelativeTimeFormat API
   */


  function formatRelativeTime(date) {
    return (0, _dayjs["default"])(date).locale(locale).fromNow();
  }

  function formatDate(format, date) {
    return (0, _dayjs["default"])(date).locale(locale).format(format);
  }

  return {
    formatDateTime: formatDateTime,
    formatDateTimeRange: formatDateTimeRange,
    formatRelativeTime: formatRelativeTime,

    /**
     * @deprecated use `formatDateTime`
     */
    formatDate: formatDate
  };
}